(() => {
  const init = () => {
    const root = document.querySelector('[data-lmm-header]');
    if (!root || root.dataset.lmmModernized === '1') return;

    root.dataset.lmmModernized = '1';

    const config = window.LMM_HEADER_MODERN || {};

    const logo = root.querySelector('.lmmh-logo img');
    if (logo && config.logoUrl) {
      logo.src = config.logoUrl;
      logo.removeAttribute('srcset');
      logo.removeAttribute('sizes');
      logo.alt = config.logoAlt || 'Leuchtmittelmarkt';
      logo.width = 170;
      logo.height = 40;
      logo.loading = 'eager';
      logo.fetchPriority = 'high';
    }

    const trustbar = root.querySelector(':scope > .lmmh-trustbar');
    const topbar = root.querySelector(':scope > .lmmh-topbar');
    const trustWrap = trustbar?.querySelector('.lmmh-trustbar__wrap');
    const reviewWrap = topbar?.querySelector('.lmmh-topbar__wrap');

    if (trustWrap || reviewWrap) {
      const utility = document.createElement('div');
      utility.className = 'lmmh-utility';

      const utilityWrap = document.createElement('div');
      utilityWrap.className = 'lmmh-utility__wrap';

      if (trustWrap) {
        trustWrap.classList.add('lmmh-utility__usps');

        const uspClasses = [
          'lmmh-usp--shipping',
          'lmmh-usp--invoice',
          'lmmh-usp--brand'
        ];

        trustWrap.querySelectorAll(':scope > .lmmh-usp').forEach((item, index) => {
          const className = uspClasses[index];
          if (className) item.classList.add(className);
        });

        const phoneLabel = String(config.phoneLabel || '').trim();
        const phoneDisplay = String(config.phoneDisplay || '').trim();
        const phoneHref = String(config.phoneHref || '').trim();

        if (phoneLabel || phoneDisplay) {
          const service = phoneHref
            ? document.createElement('a')
            : document.createElement('span');

          service.className = 'lmmh-usp lmmh-usp--service';
          if (phoneHref) service.href = phoneHref;

          const copy = document.createElement('span');
          copy.className = 'lmmh-usp__copy';

          if (phoneLabel) {
            const label = document.createElement('span');
            label.textContent = phoneLabel;
            copy.append(label);
          }

          if (phoneDisplay) {
            const number = document.createElement('strong');
            number.textContent = phoneDisplay;
            copy.append(number);
          }

          service.append(copy);
          trustWrap.append(service);
        }

        utilityWrap.append(trustWrap);
      }

      if (reviewWrap) {
        reviewWrap.classList.add('lmmh-utility__reviews');
        utilityWrap.append(reviewWrap);
      }

      utility.append(utilityWrap);
      root.insertBefore(utility, root.firstChild);
      trustbar?.remove();
      topbar?.remove();
    }

    root.classList.add('lmmh-modern-ready');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
